"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshCookie = void 0;

var _noAuthApiClient = _interopRequireDefault(require("./clients/noAuthApiClient"));

var _core = require("./middlewares/core");

var _promise = require("./helpers/promise");

var hubapi = (0, _core.standardApi)('api', 'hubapi');
var hubspot = (0, _core.standardApi)('api', 'hubspot');

var refreshCookieForApi = function refreshCookieForApi(portalId, api, withNoCacheHeader) {
  var headers = {
    'X-Force-Cookie-Refresh': true
  };

  if (withNoCacheHeader) {
    headers['X-Force-Cookie-Refresh-No-Cache'] = true;
  }

  var query = portalId ? {
    portalId: portalId
  } : {};
  var path = "/login-api/v1/cookie-refresh" + (portalId ? '' : '/hubless');
  return _noAuthApiClient.default.get(path, {
    api: api,
    headers: headers,
    withCredentials: true,
    query: query
  });
};

var refreshCookie = function refreshCookie(portalId) {
  var withNoCacheHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var refreshHubApi = refreshCookieForApi(portalId, hubapi, withNoCacheHeader);
  var refreshHubSpot = refreshCookieForApi(portalId, hubspot, withNoCacheHeader);
  return _promise.Promise.all([refreshHubApi, refreshHubSpot]);
};

exports.refreshCookie = refreshCookie;